import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FaArrowRight } from "react-icons/fa";
import { STRINGS } from "../Strings";

import aboutImgLarge from '../assets/hope.jpg';
import aboutImgSmall from '../assets/dignity.jpg';

export default function HomeAbout(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const s = STRINGS.homeAbout;

    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Initialization space
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div className="MainBodySection home-about-wrapper">
                <div className="container">
                    <div className="row align-items-center">
                        
                        {/* Left Side: Premium Overlapping Images Layer */}
                        <div className="col-12 col-lg-6 mb-5 mb-lg-0">
                            <div className="about-image-container position-relative">
                                <div className="about-image-main-frame">
                                    <img 
                                        src={aboutImgLarge} 
                                        alt="KUKAJA Community Outreach" 
                                        className="img-fluid about-img-large"
                                    />
                                </div>
                                <div className="about-image-sub-frame shadow-4">
                                    <img 
                                        src={aboutImgSmall} 
                                        alt="Supporting Vulnerable Groups" 
                                        className="img-fluid about-img-small"
                                    />
                                </div>
                                {/* Decorative Golden/Dark Experience Box */}
                                <div className="about-experience-badge d-flex flex-column justify-content-center text-center">
                                    <span className="title-font-bold exp-num">2025</span>
                                    <span className="font-semi-bold exp-text">{s.experienceBadge[language]}</span>
                                </div>
                            </div>
                        </div>

                        {/* Right Side: Text Content & Stats */}
                        <div className="col-12 col-lg-6 ps-lg-5">
                            <span className="about-top-tag font-semi-bold text-uppercase mb-2 d-inline-block">
                                {s.topTag[language]}
                            </span>
                            
                            <h2 className="title-font-bold about-heading mb-4">
                                {s.heading[language]}
                            </h2>
                            
                            <p className="font-regular about-description mb-4">
                                {s.description[language]}
                            </p>

                            {/* Stats Grid Layout */}
                            <div className="row about-stats-grid mb-5">
                                <div className="col-6 mb-4">
                                    <div className="stat-card">
                                        <h3 className="title-font-bold text-primary">{s.stats.regions.number}</h3>
                                        <p className="font-semi-bold text-muted mb-0">{s.stats.regions.label[language]}</p>
                                    </div>
                                </div>
                                <div className="col-6 mb-4">
                                    <div className="stat-card">
                                        <h3 className="title-font-bold text-primary">{s.stats.groups.number}</h3>
                                        <p className="font-semi-bold text-muted mb-0">{s.stats.groups.label[language]}</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="stat-card">
                                        <h3 className="title-font-bold text-primary">{s.stats.projects.number}</h3>
                                        <p className="font-semi-bold text-muted mb-0">{s.stats.projects.label[language]}</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="stat-card">
                                        <h3 className="title-font-bold text-primary">{s.stats.volunteers.number}</h3>
                                        <p className="font-semi-bold text-muted mb-0">{s.stats.volunteers.label[language]}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Learn More Action Button */}
                            <button
                                className="btn btn-about-more title-font-semi-bold d-inline-flex align-items-center gap-2"
                                onClick={() => appContext.navTo({ item: 'about_us' })}
                            >
                                {s.buttonText[language]}
                                <FaArrowRight size={14} />
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}